import { Box, SxProps } from '@mui/material';

type ContentProps = {
  children: React.ReactNode;
  sx?: SxProps;
};

function Content(props: ContentProps) {
  const { sx } = props;
  return (
    <Box sx={{ ...sx, flex: '1 1 auto', backgroundColor: 'background.paper', overflowY: 'auto' }}>{props.children}</Box>
  );
}

export { Content };
